import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, TextField, Select, MenuItem, Button, Checkbox, FormControlLabel, Divider, Slider } from "@mui/material";
import { AppContext } from "../context/AppContext";

const gemini_models = [
  "gemini-2.0-flash-exp",
  "gemini-exp-1206",
];
const deepseek_models = [
  "deepseek-chat",
  "deepseek-reasoner"
];
const chatgpt_models = [
  "gpt-4o",
];
const claude_models = [
  "claude-3-haiku-20240307"
];

const SettingsPanelActor = ({ name, api_provider, ai_agent }) => {
  const {
    apiError, setAPIError,
    Actor_Model_apiProvider, setActor_Model_apiProvider,
    Critic_Model_apiProvider, setCritic_Model_apiProvider,
    Actor_Model_apiModel, setActor_Model_apiModel,
    Critic_Model_apiModel, setCritic_Model_apiModel,
    Actor_Model_apikey, setActor_Model_apikey,
    Critic_Model_apikey, setCritic_Model_apikey,
    temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
    temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider
  } = useContext(AppContext);

  // Initialize state with localStorage values or defaults
  const [temperature_val, setTemperature_val] = useState(parseFloat(localStorage.getItem(`${name}-temperature_val`)) || 0.3);
  
  const [apiProvider, setApiProvider] = useState(localStorage.getItem(`${name}-apiProvider`) || (api_provider && api_provider[0]) || "Google Gemini");
  
  const [apiModel, setApiModel] = useState(() => {
    const storedModel = localStorage.getItem(`${name}-apiModel`);
    const defaultModels = {
      "Google Gemini": gemini_models[0],
      "Deepseek": deepseek_models[0],
      "OpenAI": chatgpt_models[0],
      "Anthropic": claude_models[0]
    };
    return storedModel || defaultModels[apiProvider] || gemini_models[0];
  });
  
  const [apikey, setApikey] = useState( localStorage.getItem(`${name}-apikey`) || "" );

  // Function to handle temperature change
  function temperature_function(e) {
    const newTemp = e.target.value;
    setTemperature_val(newTemp);
    setTemperature_val_Actor_Model_apiProvider(newTemp)
    localStorage.setItem(`${name}-temperature_val`, newTemp);
    
    // Update the context based on which model this is
    if (name === "Actor Model") {
      setTemperature_val_Actor_Model_apiProvider(newTemp);
    } else if (name === "Critic Model") {
      setTemperature_val_Critic_Model_apiProvider(newTemp);
    }
  }

  // Handle API provider change
  const handleApiProviderChange = (e) => {
    const newProvider = e.target.value;
    setApiProvider(newProvider);
    setActor_Model_apiProvider(newProvider)
    localStorage.setItem(`${name}-apiProvider`, newProvider);
    
    // Update model to default for the selected provider
    const defaultModels = {
      "Google Gemini": gemini_models[0],
      "Deepseek": deepseek_models[0],
      "OpenAI": chatgpt_models[0],
      "Anthropic": claude_models[0]
    };
    
    const newModel = defaultModels[newProvider] || "";
    setApiModel(newModel);
    setActor_Model_apiModel(newModel)
    localStorage.setItem(`${name}-apiModel`, newModel);
    
    // Update the context based on which model this is
    if (name === "Actor Model") {
      setActor_Model_apiProvider(newProvider);
      setActor_Model_apiModel(newModel);
    } else if (name === "Critic Model") {
      setCritic_Model_apiProvider(newProvider);
      setCritic_Model_apiModel(newModel);
    }
  };

  // Handle API model change
  const handleApiModelChange = (e) => {
    const newModel = e.target.value;
    setApiModel(newModel);
    setActor_Model_apiModel(newModel)
    localStorage.setItem(`${name}-apiModel`, newModel);
    
    // Update the context based on which model this is
    if (name === "Actor Model") {
      setActor_Model_apiModel(newModel);
    } else if (name === "Critic Model") {
      setCritic_Model_apiModel(newModel);
    }
  };

  // Handle API key change
  const handleApiKeyChange = (e) => {
    const newKey = e.target.value;
    setApikey(newKey);
    setActor_Model_apikey(newKey)
    localStorage.setItem(`${name}-apikey`, newKey);
    
    // Update the context based on which model this is
    if (name === "Actor Model") {
      setActor_Model_apikey(newKey);
    } else if (name === "Critic Model") {
      setCritic_Model_apikey(newKey);
    }
  };

  // Initialize default values in localStorage if not present
  useEffect(() => {
    if (!localStorage.getItem(`Actor Model-apiProvider`)) {
      localStorage.setItem(`Actor Model-apiProvider`, "Google Gemini");
      setActor_Model_apiProvider("Google Gemini");
    }
    if (localStorage.getItem(`Actor Model-apiProvider`)) {
      let Actor_Model_apiProvider = localStorage.getItem(`Actor Model-apiProvider`)
      setActor_Model_apiProvider(Actor_Model_apiProvider);
    }
    if (!localStorage.getItem(`Actor Model-apikey`)) {
      localStorage.setItem(`Actor Model-apikey`, "");
      setActor_Model_apikey("");
    }
    if (localStorage.getItem(`Actor Model-apikey`)) {
      let Actor_Model_apikey = localStorage.getItem(`Actor Model-apikey`)
      setActor_Model_apikey(Actor_Model_apikey);
    }
    if (!localStorage.getItem(`Actor Model-apiModel`)) {
      localStorage.setItem(`Actor Model-apiModel`, gemini_models[0]);
      setActor_Model_apiModel(gemini_models[0]);
    }
    if (localStorage.getItem(`Actor Model-apiModel`)) {
      let Actor_Model_apiModel = localStorage.getItem(`Actor Model-apiModel`)
      setActor_Model_apiModel(Actor_Model_apiModel);
    }
    if (!localStorage.getItem(`${name}-temperature_val`)) {
      localStorage.setItem(`${name}-temperature_val`, "0.3");
      setTemperature_val_Actor_Model_apiProvider(0.3);
    }
    if (localStorage.getItem(`${name}-temperature_val`)) {
      let Actor_Model_temperature_val = localStorage.getItem(`${name}-temperature_val`)
      setTemperature_val_Actor_Model_apiProvider(Actor_Model_temperature_val);
    }
    if (!localStorage.getItem(`Critic Model-apiProvider`)) {
      localStorage.setItem(`Critic Model-apiProvider`, "Google Gemini");
      setCritic_Model_apiProvider("Google Gemini");
    }
    if (localStorage.getItem(`Critic Model-apiProvider`)) {
      let Critic_Model_apiProvider = localStorage.getItem(`Critic Model-apiProvider`)
      setCritic_Model_apiProvider(Critic_Model_apiProvider);
    }
    if (!localStorage.getItem(`Critic Model-apikey`)) {
      localStorage.setItem(`Critic Model-apikey`, "");
      setCritic_Model_apikey("");
    }
    if (localStorage.getItem(`Critic Model-apikey`)) {
      let Critic_Model_apikey = localStorage.getItem(`Critic Model-apikey`)
      setCritic_Model_apikey(Critic_Model_apikey);
    }
    if (!localStorage.getItem(`Critic Model-apiModel`)) {
      localStorage.setItem(`Critic Model-apiModel`, gemini_models[0]);
      setCritic_Model_apiModel(gemini_models[0]);
    }
    if (localStorage.getItem(`Critic Model-apiModel`)) {
      let Critic_Model_apiModel = localStorage.getItem(`Critic Model-apiModel`)
      setCritic_Model_apiModel(Critic_Model_apiModel);
    }
    if (!localStorage.getItem(`${name}-temperature_val`)) {
      localStorage.setItem(`${name}-temperature_val`, "0.3");
      setTemperature_val_Critic_Model_apiProvider(0.3);
    }
    if (localStorage.getItem(`${name}-temperature_val`)) {
      let Critic_Model_temperature_val = localStorage.getItem(`${name}-temperature_val`)
      setTemperature_val_Critic_Model_apiProvider(Critic_Model_temperature_val);
    }
  }, []);

  return (
    <Box sx={{ width: 400, padding: 0, borderRadius: 2, backgroundColor: "transparent", color: "black", display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={{ lineHeight: "-15px", marginBottom: "-10px" }}>
        <Typography variant="body2" sx={{ marginBottom: 1, fontSize: 18, fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, fontWeight: "750" }}>{name}</Typography>
        <Typography variant="body2" sx={{ marginBottom: "-2px", fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, fontWeight: "750", letterSpacing: "0px" }}>API Provider</Typography>
        <Select 
          value={apiProvider} 
          onChange={handleApiProviderChange} 
          fullWidth 
          sx={{ backgroundColor: "#808080d4", color: "#fff", borderColor: "transparent", width: "80%", height: "35px", paddingTop: "5px" }}
        >
          {api_provider?.map((provider) => (
            <MenuItem key={provider} value={provider}>{provider}</MenuItem>
          ))}
        </Select>
      </Box>
      <Box sx={{ lineHeight: "-15px", marginBottom: "-10px" }}>
        <Typography variant="body2" sx={{ marginBottom: "-2px", fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, fontWeight: "750", letterSpacing: "0px" }}>API Key</Typography>
        <TextField 
          type="text" 
          value={apikey} 
          onChange={handleApiKeyChange} 
          fullWidth 
          sx={{ "& .MuiInputBase-root": { backgroundColor: "#808080d4", color: "#fff", borderColor: "transparent", width: "98%", height: "35px", paddingTop: "5px" } }} 
        />
      </Box>
      <div style={{ display: "flex", flexDirection: "column", justifyContent: "start", fontSize: "16px", color: "rgb(75, 85, 99)" }}>
        <div style={{ fontFamily: '"Arial"', marginTop: "-3px", fontSize: "13px", color: "rgb(75, 85, 99)" }}>This key is stored locally and only used to make API requests from this extension.</div>
      </div>
      <Box sx={{ lineHeight: "-15px", marginTop: "6px", marginBottom: "-10px" }}>
        <Typography variant="body2" sx={{ marginBottom: "-2px", fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, fontWeight: "750", letterSpacing: "0px" }}>Model</Typography>
        <Select 
          value={apiModel} 
          onChange={handleApiModelChange} 
          fullWidth 
          sx={{ backgroundColor: "#808080d4", color: "#fff", borderColor: "transparent", width: "80%", height: "35px", paddingTop: "5px" }}
        >
          {apiProvider === "Google Gemini" && gemini_models.map((model) => (
            <MenuItem key={model} value={model}>{model}</MenuItem>
          ))}
          {apiProvider === "Deepseek" && deepseek_models.map((model) => (
            <MenuItem key={model} value={model}>{model}</MenuItem>
          ))}
          {apiProvider === "OpenAI" && chatgpt_models.map((model) => (
            <MenuItem key={model} value={model}>{model}</MenuItem>
          ))}
          {apiProvider === "Anthropic" && claude_models.map((model) => (
            <MenuItem key={model} value={model}>{model}</MenuItem>
          ))}
        </Select>
        <div style={{ fontFamily: '"Arial"', marginTop: "1.2px", fontSize: "13px", color: "rgb(75, 85, 99)" }}>
          {apiProvider === "Google Gemini" && (
            <>
              <span style={{ fontWeight: "750", marginTop: "10px" }}>Max output: </span> 8,192 tokens
            </>
          )}
          {apiProvider === "Deepseek" && (
            <>
              <span style={{ fontWeight: "750", marginTop: "10px" }}>Max output: </span> 8,000 tokens
            </>
          )}
          {apiProvider === "OpenAI" && (
            <>
              <span style={{ fontWeight: "750", marginTop: "10px" }}>Max output: </span> 16,384 tokens
            </>
          )}
          {apiProvider === "Anthropic" && (
            <>
              <span style={{ fontWeight: "750", marginTop: "10px" }}>Max output: </span> 8,192 tokens
            </>
          )}
        </div>
        {!ai_agent && (
          <>
            <Typography variant="body2" sx={{ marginTop: "6.5px", marginBottom: "-12px", fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`, fontWeight: "750", letterSpacing: "0px" }}>Temperature</Typography>
            <Slider 
              size="small" 
              value={temperature_val} 
              onChange={temperature_function} 
              valueLabelDisplay="auto" 
              aria-label="Temperature" 
              step={0.1} 
              min={0} 
              max={1.0} 
              sx={{ color: "rgb(75, 85, 99)" }}
            />
          </>
        )}
      </Box>
      <Divider sx={{ backgroundColor: "#333", marginTop: ai_agent ? "10px" : "0px", marginBottom: "0px", color: "#333" }} />
    </Box>
  );
};

export default SettingsPanelActor;